import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs";

interface RegistryEntry {
  id: string;
  interceptor: HttpInterceptor;
}

@Injectable({
  providedIn: "root"
})
export class InterceptorManagerService {
  readonly #registry: RegistryEntry[] = [];

  addInterceptor(id: string, interceptor: HttpInterceptor): void {
    const index: number = this.#registry.findIndex(
      (entry: RegistryEntry) => entry.id === id
    );

    if (index >= 0) {
      this.#registry[index] = { id, interceptor };
    } else {
      this.#registry.push({ id, interceptor });
    }
  }

  removeInterceptor(id: string): void {
    const index: number = this.#registry.findIndex(
      (entry: RegistryEntry) => entry.id === id
    );

    if (index >= 0) {
      this.#registry.splice(index, 1);
    }
  }

  run(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
  ): Observable<HttpEvent<unknown>> {
    const list: RegistryEntry[] = [...this.#registry];
    if (list.length === 0) {
      return next(req);
    }

    const createHandler = (index: number): HttpHandler =>
      ({
        handle: (
          request: HttpRequest<unknown>
        ): Observable<HttpEvent<unknown>> =>
          index >= list.length
            ? next(request)
            : list[index].interceptor.intercept(
                request,
                createHandler(index + 1)
              )
      }) as HttpHandler;

    return createHandler(0).handle(req);
  }
}
